import { useRecoilValue } from "recoil";
import { CustomerListType, DepartmentRequestType, DepartmentType, PermissionsType, SecretarySimpleType, UserType } from "../../../types/types";
import { AbcOutlined, BadgeOutlined, CheckCircleRounded, CloseOutlined, DeleteForeverOutlined, DirectionsCarFilledOutlined, DoNotDisturbOnRounded, DriveFileRenameOutlineOutlined, EmailOutlined, HailOutlined, HelpOutlineOutlined, HideImageOutlined, InfoOutlined, KeyOutlined, LocalAirportOutlined, LocationCityOutlined, ManOutlined, Person, PersonOutlineOutlined, PhoneOutlined, PinOutlined, PlaceOutlined, ReduceCapacityOutlined, RemoveCircleOutlineOutlined, SaveOutlined } from "@mui/icons-material";
import { Autocomplete, Box, Button, Chip, FormControl, Grid, IconButton, InputLabel, Paper, Skeleton, TextField, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { ChangeEvent, SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ContentProps, Toast } from "primereact/toast";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";

import { CNPJFormatter, getFilteredList, phoneNumberFormatter, setToastRefToOpen } from "../../../functions/functions";
import GridTemplate from "../../../components/GridTemplate";
import Rmodal from "../../../components/Rmodal";
import { userAtom } from "../../../atoms/atoms";
import departmentFindAllCrudResponse from "../../../resources/Api/department/departmentFindAllCrudResponse";
import departmentOnSaveData from "../../../resources/Api/department/departmentOnSaveData";
import departmentOnUpdateData from "../../../resources/Api/department/departmentOnUpdateData";
import departmentUpdateStatusById from "../../../resources/Api/department/departmentUpdateStatusById";
import departmentFindAllExportResponse from "../../../resources/Api/department/departmentFindAllExportResponse";
import { customerDefault, MENUS_ITENS, secretaryDefault } from "../../../consts/consts";
import customerFindAllListResponse from "../../../resources/Api/customer/customerFindAllListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={
                    <KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "reducedName",
        align: "left",
        width: 250,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Nome fantasia"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.reducedName}
            />
        ),
    },
    {
        field: "cnpj",
        width: 200,
        align: "left",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"CNPJ"}
                icon={
                    <BadgeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={CNPJFormatter(item.row.cnpj)}
            />
        ),
    },
    {
        field: "email",
        align: "left",
        width: 250,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"E-mail"}
                icon={
                    <EmailOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.email}
            />
        ),
    },
    {
        field: "accessIcon",
        sortable: false,
        headerName: "",
        width: 320,
        renderCell: (item) => {
            const getItemPermission = (id: number) => {
                return item.row.permissions.find((permission: PermissionsType) => {
                    if (permission.optionItem.id === id) {
                        const { optionItem, ...rest } = permission;
                        return rest;
                    };
                });
            };
            //const driverMenuItemId = 4;
            const driverPermission = getItemPermission(Number(MENUS_ITENS.DRIVERS));
            // const vehicleMenuItemId = 9;
            const vehiclePermission = getItemPermission(Number(MENUS_ITENS.VEHICLES));
            return (
                <>
                    {(driverPermission?.canView && item.row.canshowOption) && <Chip
                        className="chip-access"
                        sx={{
                            marginRight: 2,
                            fontFamily: "Prometo",
                            background: "#00B700",
                            color: "#ffff",
                            padding: 1,
                        }}
                        onClick={() => {
                            item.row.navigate?.("/customers/secretaries/departments/drivers", item.id, driverPermission);
                        }}
                        label="Motoristas"
                        icon={
                            <HailOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                        }
                    />}
                    {(vehiclePermission?.canView && item.row.canshowOption) &&
                        <Chip
                            className="chip-access"
                            sx={{
                                marginRight: 2,
                                fontFamily: "Prometo",
                                background: "#00B700",
                                color: "#ffff",
                                padding: 1,
                            }}
                            onClick={() => {
                                item.row.navigate?.("/customers/secretaries/departments/vehicles", item.id, vehiclePermission);
                            }}
                            label="Veículos"
                            icon={
                                <DirectionsCarFilledOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                            }
                        />}
                </>
            )
        },
    },
];

const rowsOptions = (
    list: Array<DepartmentType>,
    permissions: Array<PermissionsType>,
    navigate: (...args: any) => void,
    canshowOption: boolean = true,
): Array<DepartmentType> => {
    const result = [...list];
    return result.map((item) => ({ ...item, navigate, permissions, canshowOption }));
};

/**
 * DepartmentPage - Component that renders a page to list, create and manage departments
 * @component
 */
const DepartmentPage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    //atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // functionalities states
    const [isOnline, setIsOnline] = useState(true);
    const [loading, setLoading] = useState(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<DepartmentType>>([]);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    // states
    const [departmentList, setDepartmentList] = useState<Array<DepartmentType>>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<DepartmentType>({
        id: -1,
    } as any);

    const [departmentName, setDepartmentName] = useState<string>("");

    const [departmentReducedName, setDepartmentReducedName] = useState<string | null>("");
    const [departmentCnpj, setDepartmentCnpj] = useState<string | null>("");

    const [departmentAddress, setDepartmentAddress] = useState<string>("");
    const [departmentPhone, setDepartmentPhone] = useState<string>("");
    const [departmentEmail, setDepartmentEmail] = useState<string>("");

    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);
    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    // refs
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);

    // hooks e const
    const location = useLocation();
    const navigate = useNavigate();

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setInEdit(false);
        setInInsert(false);
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setSelectedDepartment({} as any);
        setInEdit(false);
        setInInsert(false);
        setDepartmentName("");
        setDepartmentReducedName("");
        setDepartmentCnpj("");
        setDepartmentAddress("");
        setDepartmentEmail("");
        setDepartmentPhone("");
    }, []);

    useEffect(() => {
        const ref = isOpenDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const goToRoute = useCallback(
        async (path: string, state?: any) => {
            const hasConection: boolean = window.navigator.onLine;
            if (hasConection) {
                navigate(path, { state: state });
            } else {
                setIsOnline(false);
            }
        },
        [navigate]
    );

    const getAllDepartaments = useCallback(
        async (status: string = "activated", page: number = 0, size: number = 100) => {

            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = location?.state?.customerId ?? customer.id;
            const secretaryId = location?.state?.secretaryId ?? secretary.id;

            setLoading(true);
            try {
                const { data } = await departmentFindAllCrudResponse(token, customerId, secretaryId, status, page, size);
                setDepartmentList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements)
                setPageNumber(data.pageable.pageNumber)

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setDepartmentList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, location?.state?.customerId, location?.state?.secretaryId, customer.id, secretary.id]
    );

    useEffect(() => {
        getAllDepartaments();
    }, [getAllDepartaments]);

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? customer.id;
        const secretaryId = location?.state?.secretaryId ?? secretary.id;

        setLoading(true);

        const data: DepartmentRequestType = {
            id: -1,
            name: departmentName,
            reducedName: departmentReducedName,
            phone: departmentPhone,
            email: departmentEmail,
            cnpj: departmentCnpj,
            customerId: customerId,
            secretaryId: secretaryId,
            address: departmentAddress,
        };

        if (
            !data.name ||
            !data.address ||
            !data.phone ||
            !data.email
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await departmentOnSaveData(token, data);
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDepartaments();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        cookies.token,
        departmentName,
        departmentReducedName,
        location?.state?.customerId,
        location?.state?.secretaryId,
        departmentCnpj,
        departmentAddress,
        departmentPhone,
        departmentEmail,
        handleClose,
        getAllDepartaments,
        customer.id,
        secretary.id,
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? customer.id;
        const secretaryId = location?.state?.secretaryId ?? secretary.id;

        setLoading(true);

        const data: DepartmentRequestType = {
            id: selectedDepartment.id,
            name: departmentName,
            reducedName: departmentReducedName,
            phone: departmentPhone,
            email: departmentEmail,
            cnpj: departmentCnpj,
            customerId: customerId,
            secretaryId: secretaryId,
            address: departmentAddress
        };

        if (
            !data.name ||
            !data.address ||
            !data.phone ||
            !data.email
        ) {
            setTextValidation(
                "Todos os campos são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        if (
            data.name === selectedDepartment.name &&
            ((data.cnpj && data.reducedName === selectedDepartment.reducedName)?.valueOf() ?? true) &&
            data.cnpj === selectedDepartment.cnpj &&
            data.address === selectedDepartment.address &&
            data.phone === selectedDepartment.phone &&
            data.email === selectedDepartment.email
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await departmentOnUpdateData(token, data, data.id);
            setTextValidation("Registro atualizado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDepartaments();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        cookies.token,
        departmentName,
        departmentReducedName,
        location?.state?.customerId,
        location?.state?.secretaryId,
        departmentCnpj,
        departmentAddress,
        departmentPhone,
        departmentEmail,
        selectedDepartment,
        handleClose,
        getAllDepartaments,
        customer.id,
        secretary.id
    ]);

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            setLoading(true);
            try {
                await departmentUpdateStatusById(
                    token,
                    id,
                    status
                );
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllDepartaments();
                }, 8000);
            }
        },
        [cookies.token, getAllDepartaments, handleClose]
    );

    const getReport = useCallback(async (type: string) => {
        setLoading(true);
        // const customerId = location?.state?.customerId ?? customer.id;
        const secretaryId = location?.state?.secretaryId ?? secretary.id;

        let reportType = type;
        let isSimpleType = false;
        if (type.includes("simple")) {
            reportType = reportType.split(" ")[0];
            isSimpleType = true;
        };
        // simpleXlsxExport = false

        let dataBuffer = new ArrayBuffer(0);
        try {
            const { data } = await departmentFindAllExportResponse(cookies.token, secretaryId,
                (departmentList.length > 0 && departmentList[0].activated)
                    ? "activated"
                    : "deactivated", reportType, )

            if ((data as ArrayBuffer).byteLength === 0) {
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } else {
                setTextValidation("Relatório gerado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
                dataBuffer = data;
            }
        } catch (error: any) {
            const { data } = error.response

            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(data.reason);
        } finally {
            setTimeout(() => {
                handleClose();
                setReport(dataBuffer);
                setExportType(type);
            }, 3000);
        }
    }, [cookies.token, departmentList, location?.state?.secretaryId, handleClose, secretary.id]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport = (exportType === "pdf" ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    useEffect(() => {
        setFilteredList(
            getFilteredList(["reducedName", "cnpj", "email"], departmentList, query)
        );
    }, [departmentList, query]);

    const verifyBeforeCancel = useCallback(
        (selected: DepartmentType) => {
            const ref = toastModalRef;
            let canCancel = true;

            if (inEdit && !inInsert) {
                if (
                    departmentName !== selected.name ||
                    (departmentCnpj && departmentReducedName !== selected.reducedName) ||
                    departmentCnpj !== selected?.cnpj ||
                    departmentAddress !== selected.address ||
                    departmentPhone !== selected.phone ||
                    departmentEmail !== selected.email
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert &&
                (departmentName ||
                    departmentReducedName ||
                    departmentCnpj ||
                    departmentAddress ||
                    departmentPhone ||
                    departmentEmail
                )
            ) {
                canCancel = false;
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            departmentAddress,
            departmentCnpj,
            departmentEmail,
            departmentName,
            departmentReducedName,
            departmentPhone
        ]
    );

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const handleOnEditValues = useCallback(async (selectedDepartment: DepartmentType) => {
        if (selectedDepartment?.name && !inInsert) {
            setDepartmentName(selectedDepartment.name);
            setDepartmentReducedName(selectedDepartment?.cnpj || selectedDepartment?.reducedName ? selectedDepartment?.reducedName : "");
            setDepartmentCnpj(selectedDepartment?.cnpj);
            setDepartmentAddress(selectedDepartment.address);
            setDepartmentPhone(selectedDepartment.phone);
            setDepartmentEmail(selectedDepartment.email);
        }
    }, [
        inInsert
    ]);

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                hiddenBackdrop={false}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={style}
                >
                    <Box
                        className="row tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffff", transition: "box-shadow 200ms ease, background-color 200ms ease" },
                            "& .MuiOutlinedInput-root:hover": { backgroundColor: "rgba(0, 108, 119, 0.02)" },
                            "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 108, 119, 0.10)" },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#006C77" },
                        }}
                    >
                        {!loading ? (
                            <>

                                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Identificação
                                    </Typography>
                                </Box>
                                <Box
                                    className="col-sm-12 col-md-5"
                                    style={{ display: "flex", justifyContent: "end" }}
                                >
                                    {selectedDepartment?.name && (
                                        <>
                                            <Chip
                                                style={{
                                                    color: selectedDepartment.activated
                                                        ? "#00B700"
                                                        : "#dc3545",
                                                    marginRight: 5,
                                                    width: "50%",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={
                                                    selectedDepartment.activated ? "Ativo" : "Inativo"
                                                }
                                            />
                                            {selectedDepartment.activated && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        width: "50%",
                                                    }}
                                                    disabled={(location?.state?.permissions?.canEdit === false) || (location?.state?.canEdit === false)}
                                                    onClick={() => {
                                                        setInEdit(true);
                                                    }}
                                                    label="Editar"
                                                    icon={
                                                        <DriveFileRenameOutlineOutlined
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "black",
                                                            }}
                                                        />
                                                    }
                                                />
                                            )}
                                            {false && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        width: "50%",
                                                    }}
                                                    disabled={true}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            handleClose();
                                                            // verifyBeforeDelete(selectedGroup.id);
                                                        }
                                                    }}
                                                    label="Excluir"
                                                    icon={
                                                        <DeleteForeverOutlined
                                                            style={{
                                                                height: 24,
                                                                width: 24,
                                                                fill: "black",
                                                            }}
                                                        />
                                                    }
                                                />
                                            )}

                                            <Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    width: "50%",
                                                }}
                                                disabled={(location?.state?.permissions?.canEdit === false) || (location?.state?.canEdit === false)}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        verifyBeforeUpdateStatus(
                                                            selectedDepartment.id,
                                                            selectedDepartment.activated
                                                                ? "deactivate"
                                                                : "activate"
                                                        );
                                                    }
                                                }}
                                                label={
                                                    selectedDepartment.activated ? "Desativar" : "Ativar"
                                                }
                                                icon={
                                                    <RemoveCircleOutlineOutlined
                                                        style={{ height: 24, width: 24, fill: "black" }}
                                                    />
                                                }
                                            />
                                        </>
                                    )}
                                </Box>

                                <Box className="row">
                                    <Box
                                        className="col-md-12"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-name-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Nome
                                            </InputLabel>
                                            <TextField
                                                name="name"
                                                InputProps={{
                                                    label: "Nome",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                required
                                                value={departmentName}
                                                onChange={(
                                                    event: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentName(event.target.value);
                                                }}
                                                type="text"
                                                autoComplete="off"
                                                className="form-control form-control-login"
                                                placeholder="Digite o nome"
                                            />
                                            <IconButton
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(event: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PersonOutlineOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-12"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-name-label"
                                                shrink
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Nome fantasia
                                            </InputLabel>
                                            <TextField
                                                name="reducedName"
                                                InputProps={{
                                                    label: "Nome fantasia",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={departmentReducedName}
                                                onChange={(
                                                    event: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentReducedName(event.target.value);
                                                }}
                                                type="text"
                                                autoComplete="off"
                                                className="form-control form-control-login"
                                                placeholder="Digite o nome fantasia (Opcional)"
                                            />
                                            <IconButton
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(event: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PersonOutlineOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-cpf-label"
                                                shrink
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            >
                                                CNPJ
                                            </InputLabel>
                                            <TextField
                                                name="cnpj"
                                                type="cnpj"
                                                autoComplete="off"
                                                inputProps={{ maxLength: 14 }}
                                                InputProps={{ label: "CNPJ", notched: true }}
                                                placeholder="Digite o CNPJ (Opcional)"
                                                className="form-control department-cnpj"
                                                value={CNPJFormatter(departmentCnpj)}
                                                onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentCnpj(event.target.value);
                                                }}
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            />
                                            <IconButton
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PinOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-address-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Endereço
                                            </InputLabel>
                                            <TextField
                                                name="address"
                                                InputProps={{
                                                    label: "Endereço",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={departmentAddress}
                                                onChange={(
                                                    event: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentAddress(event.target.value);
                                                }}
                                                type="text"
                                                autoComplete="off"
                                                required
                                                className="form-control form-control-login"
                                                placeholder="Digite o endereço"
                                            />
                                            <IconButton
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PlaceOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 20px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-name-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            >
                                                Telefone
                                            </InputLabel>
                                            <TextField
                                                name="phoneNumber"
                                                type="tel"
                                                autoComplete="off"
                                                InputProps={{ label: "Telefone", notched: true }}
                                                inputProps={{ maxLength: 11 }}
                                                className="form-control phone"
                                                placeholder="Digite o telefone"
                                                required
                                                inputMode="numeric"
                                                value={phoneNumberFormatter(departmentPhone)}
                                                onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentPhone(event.target.value);
                                                }}
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PhoneOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 20px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-mail-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                            >
                                                E-mail
                                            </InputLabel>
                                            <TextField
                                                name="email"
                                                type="email"
                                                autoComplete="off"
                                                InputProps={{ label: "E-mail", notched: true }}
                                                placeholder="Digite o e-mail"
                                                className="form-control form-control-login"
                                                disabled={
                                                    (selectedDepartment?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={departmentEmail}
                                                required
                                                onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    setDepartmentEmail(event.target.value);
                                                }}
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <EmailOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>
                                </Box>
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{ display: "flex", width: "100%", alignSelf: "stretch", justifyContent: "flex-end", padding: 2, borderTop: "1px solid rgba(0, 0, 0, 0.10)", backgroundColor: "#ffff" }}
                    >
                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedDepartment);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            <Button
                                type="button"
                                style={{ fontFamily: "Prometo", color: "#ffff" }}
                                disabled={!inEdit && !inInsert}
                                onClick={() => {
                                    inInsert && !inEdit ? onSave() : onUpdate();
                                }}
                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <SaveOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Salvar
                                </Typography>
                            </Button>
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        handleClose,
        location?.state?.canEdit,
        verifyBeforeCancel,
        departmentName,
        departmentReducedName,
        departmentCnpj,
        departmentAddress,
        departmentPhone,
        departmentEmail,
        verifyBeforeUpdateStatus,
        location?.state?.permissions?.canEdit,
        isToastVisible,
        validationText,
        selectedDepartment,
        isOpenDetails,
        loading,
        loadingEsqueleton,
        inInsert,
        inEdit,
        onSave,
        onUpdate
    ]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, cookies.selectedParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, cookies.selectedParameters.customer.id]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && (location?.state?.customerId === undefined)) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager, location?.state?.customerId]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, customer?.id]);

    useEffect(() => {
        if (customer?.name) {
            getSecretariesList();
        }
    }, [getSecretariesList, customer?.name]);

    const customerParam =
        <>
            <Box className="col-md-6">
                <Autocomplete
                    id="chip-label-select-customer"
                    className="input-select-customer"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    options={customersList}
                    value={customer}
                    onChange={(_, option) => {
                        setCustomer(option ?? customerDefault);
                        setSecretary(secretaryDefault);
                    }}
                    disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Cliente
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um cliente"
                                    style={{ background: "#ffff", borderRadius: 5 }}
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Cliente",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>

            <Box className="col-md-6">
                <Autocomplete
                    id="chip-label-select-secretary"
                    className="input-select-secretary"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    options={secretariesList}
                    value={secretary}
                    onChange={(_, option) => {
                        setSecretary(option ?? secretaryDefault);
                    }}
                    disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Secretaria
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione uma secretaria"
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Secretaria",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>
        </>;

    return (
        <>
            {DetailsModal}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);
                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName={"Departamentos"}
                isHiddenMenu={isHiddenMenu}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList, getCurrentUser.permissions, (route: string, departmentId: number, permissions: PermissionsType) => {
                    goToRoute(route, { permissions, customerId: location?.state?.customerId, secretaryId: location?.state?.secretaryId, departmentId: departmentId, departmentName: departmentList.find(it => it.id === departmentId)?.name });
                }, (location?.state?.customerId ? true : false))}
                sortField="name"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Nome fantasia, CNPJ ou E-mail"}
                onRefresh={getAllDepartaments}
                onExport={getReport}
                disableAddButton={((location?.state?.permissions?.canCreate === false) || (location?.state?.canCreate === false))}
                handleNext={(activated: string, page: number, size: number) => getAllDepartaments(activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedDepartment(item);
                    handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                withCustomerParameter={(location?.state?.customerId ? false : true)}
                customerParameter={customerParam}
            />
        </>
    );
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default DepartmentPage;
